import { render, staticRenderFns } from "./ProjectActivityInspection.vue?vue&type=template&id=2b45544d&"
import script from "./ProjectActivityInspection.vue?vue&type=script&lang=js&"
export * from "./ProjectActivityInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports